import axios from 'axios';

const API_URL = process.env.API_URL;

export async function getListArtist(filter) {
  const url = `${API_URL}/admin/user-artist/list`;
  const accessType = localStorage.getItem('token_type');
  const accessToken = localStorage.getItem('access_token');
  return axios({ url,
    method: 'get',
    params: filter,
    headers: {
      Authorization: `${accessType} ${accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getListArtistBio(filter) {
  const url = `${API_URL}/admin/user-artist/list-bio`;
  const accessType = localStorage.getItem('token_type');
  const accessToken = localStorage.getItem('access_token');
  return axios({ url,
    method: 'get',
    params: filter,
    headers: {
      Authorization: `${accessType} ${accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getListArtistDraft(filter) {
  const url = `${API_URL}/admin/user-artist/list-draft`;
  const accessType = localStorage.getItem('token_type');
  const accessToken = localStorage.getItem('access_token');
  return axios({ url,
    method: 'get',
    params: filter,
    headers: {
      Authorization: `${accessType} ${accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getDetailArtist(idArtist) {
  const url = `${API_URL}/admin/user-artist/detail/${idArtist}`;
  const accessType = localStorage.getItem('token_type');
  const accessToken = localStorage.getItem('access_token');
  return axios({ url,
    method: 'get',
    headers: {
      Authorization: `${accessType} ${accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function setBlockArtist(idArtist) {
  const url = `${API_URL}/admin/user-artist/block`;
  const accessType = localStorage.getItem('token_type');
  const accessToken = localStorage.getItem('access_token');
  return axios({ url,
    method: 'post',
    data: { id: idArtist },
    headers: {
      Authorization: `${accessType} ${accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}
export async function setUnblockArtist(idArtist) {
  const url = `${API_URL}/admin/user-artist/unblock`;
  const accessType = localStorage.getItem('token_type');
  const accessToken = localStorage.getItem('access_token');
  return axios({ url,
    method: 'post',
    data: { id: idArtist },
    headers: {
      Authorization: `${accessType} ${accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}
export async function updateCutCalculation(cutData, authorization) {
  const url = `${API_URL}/admin/user-artist/update-cut-calculation`;
  return axios({
    url,
    method: 'post',
    data: cutData,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function deleteArtistByEmail(email) {
  const url = `${API_URL}/admin/user-artist/delete-by-email`;
  const accessType = localStorage.getItem('token_type');
  const accessToken = localStorage.getItem('access_token');
  return axios({ url,
    method: 'post',
    data: { email },
    headers: {
      Authorization: `${accessType} ${accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function editBio(data, authorization) {
  const url = `${API_URL}/admin/user-artist/update-bio`;
  return axios({
    url,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}
export async function approvalBio(data, authorization) {
  const url = `${API_URL}/admin/user-artist/approve-bio`;
  return axios({
    url,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function resendEmail(data, authorization) {
  const url = `${API_URL}/admin/user-artist/resend-activation-email`;
  return axios({
    url,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function addArtist(data, authorization) {
  const url = `${API_URL}/admin/user-artist/add`;
  return axios({
    url,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function updateArtist(data, authorization) {
  const url = `${API_URL}/admin/user-artist/edit`;
  return axios({
    url,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function publishArtist(data, authorization) {
  const url = `${API_URL}/admin/user-artist/publish`;
  return axios({
    url,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getUrlStatement(id, authorization) {
  const url = `${API_URL}/admin/user-artist/statement`;
  return axios({
    url,
    method: 'get',
    params:{user_id:id},
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getListArtistApplication(filter) {
  const url = `${API_URL}/admin/artist-application/list`;
  const accessType = localStorage.getItem('token_type');
  const accessToken = localStorage.getItem('access_token');
  return axios({ url,
    method: 'get',
    params: filter,
    headers: {
      Authorization: `${accessType} ${accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getDetailArtistApplication(id) {
  const url = `${API_URL}/admin/artist-application/detail/${id}`;
  const accessType = localStorage.getItem('token_type');
  const accessToken = localStorage.getItem('access_token');
  return axios({ url,
    method: 'get',
    headers: {
      Authorization: `${accessType} ${accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function downloadArtistApplicationFile(id, fileId) {
  const url = `${API_URL}/admin/artist-application/download-file/${id}/${fileId}`;
  const accessType = localStorage.getItem('token_type');
  const accessToken = localStorage.getItem('access_token');
  return axios({ url,
    method: 'get',
    headers: {
      Authorization: `${accessType} ${accessToken}`,
    },
    responseType: 'blob',
  }).then(response => response).catch((err) => {
    throw err.response;
  });
}

export async function approveArtistApplication(data, authorization) {
  const url = `${API_URL}/admin/artist-application/approve`;
  return axios({
    url,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function rejectArtistApplication(data, authorization) {
  const url = `${API_URL}/admin/artist-application/reject`;
  return axios({
    url,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}



// WEBPACK FOOTER //
// ./src/services/artist.js